module.exports = __webpack_public_path__ + "components/flag/static/square/gb-wls-d47ecf1363efdecd69ff8c138cbe8c06.svg";